export default __webpack_public_path__ + "static/media/linkedinBlueColor.36b2161c.svg";